import React, { useEffect, useRef, useState } from "react";
import { useSearchParams, useNavigate, useParams } from "react-router-dom";
import { api } from "../lib/api";
import PhoneShell from "../components/PhoneShell";
import { clearCart } from "../lib/session";

const PaymentSuccess = () => {
    const [params] = useSearchParams();
    const sessionId = params.get("session_id");
    const { slug } = useParams();
    const nav = useNavigate();
    const [status, setStatus] = useState("checking");
    const attempts = useRef(0);

    useEffect(() => {
        clearCart();
        if (!sessionId) {
            nav(`/${slug}`);
            return;
        }
        let stopped = false;

        const poll = async () => {
            if (stopped) return;
            attempts.current += 1;
            try {
                const r = await api.get(`/payments/status/${sessionId}`);
                if (r.data.payment_status === "paid") {
                    const o = await api.get(`/orders/by-session/${sessionId}`);
                    nav(`/${slug}/confirmation/${o.data.id}`, { replace: true });
                    return;
                }
                if (r.data.payment_status === "expired" || r.data.payment_status === "failed") {
                    setStatus("failed");
                    return;
                }
            } catch (e) {
                // continue
            }
            if (attempts.current > 20) {
                setStatus("timeout");
                return;
            }
            setTimeout(poll, 2000);
        };
        poll();
        return () => {
            stopped = true;
        };
    }, [sessionId, nav, slug]);

    return (
        <PhoneShell>
            <div className="min-h-screen flex flex-col items-center justify-center p-8 text-center">
                {status === "checking" && (
                    <>
                        <div className="h-16 w-16 rounded-full border-4 border-[#E8DCCB] border-t-[#FF4F18] animate-spin" />
                        <div className="mt-6 font-display font-black text-2xl">Confirming payment…</div>
                        <div className="mt-1 text-[#8C7A72] text-sm">Give us a sec while Stripe pings back.</div>
                    </>
                )}
                {status === "failed" && (
                    <>
                        <div className="font-display font-black text-2xl">Payment didn’t go through</div>
                        <button
                            onClick={() => nav(`/${slug}/cart`)}
                            className="mt-6 px-6 py-3 rounded-full bg-[#FF4F18] text-white font-display font-bold"
                        >
                            Back to cart
                        </button>
                    </>
                )}
                {status === "timeout" && (
                    <>
                        <div className="font-display font-black text-2xl">Still checking…</div>
                        <div className="mt-2 text-[#8C7A72] text-sm">
                            Refresh in a moment or contact the counter.
                        </div>
                    </>
                )}
            </div>
        </PhoneShell>
    );
};

export default PaymentSuccess;
